/* This file is autogenerated, see readme.md for instructions */
import BrowserSvgIcon from '@bloomreach/banana-theme/icons/browser.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const BrowserIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <BrowserSvgIcon />
    </Icon>
  );
});

BrowserIcon.displayName = 'BrowserIcon';

export default BrowserIcon;
